/** Work package number for document ND suffix (e.g. WP3 -> "3"). */
export function wpNumberForNdSuffix(code?: string, counter?: number | null): string {
  if (code) {
    const match = code.trim().match(/^WP(\d+)/i);
    if (match) return String(parseInt(match[1], 10));
  }
  if (counter != null) return String(counter);
  return '0';
}

/** Work unit index within its work package (e.g. WU3.2 -> "2"). */
export function wuIndexWithinPackageForNdSuffix(code?: string): string {
  if (code) {
    const dotted = code.trim().match(/^WU\d+\.(\d+)/i);
    if (dotted) return String(parseInt(dotted[1], 10));
    const plain = code.trim().match(/^WU(\d+)$/i);
    if (plain) return String(parseInt(plain[1], 10));
  }
  return '0';
}
